export default __webpack_public_path__ + "static/uni-2479e47e3d7f43ab5f10f1676e679572.png";